<div class="card-body">
  <div class="row">
    <div class="form-group col-md-12">
      <label for="exampleInputEmail1"> کلید واژه </label>
      <input type="text" class="form-control" (keyup)="ReadData_DeviceBehfa_KeySearch()"
        [(ngModel)]="Search_Code_DeviceBehfa_Table" placeholder="برای جستجو اینجا تایپ کنید ...">
    </div>
  </div>

  <div class="row">
    <div class="form-group col-md-6">
      <label for="exampleInputEmail1">گروه</label>
      <select (change)="Read_Second_Device_Group()" name="First_Device_Group_Selected"
        [(ngModel)]="First_Device_Group_Selected" class="custom-select">
        <option value="0">همه موارد</option>
        <option *ngFor="let item of DataList_First_Device_Group" [value]="item.id">{{item.title}}</option>
      </select>
    </div>

    <div class="form-group col-md-6">
      <label for="exampleInputEmail1">زیر گروه</label>
      <select [(ngModel)]="Second_Device_Group_Selected" name="Second_Device_Group_Selected" class="custom-select">
        <option value="0">همه موارد</option>
        <option *ngFor="let item of DataList_Second_Device_Group" [value]="item.id">{{item.title}}</option>
      </select>
    </div>
  </div>

  <div class="row">
    <div class="form-group col-md-12">
      <img *ngIf="Procssing_DeviceBehfa" src="assets/Loading.gif" style="width: 25px;" />
      <button *ngIf="!Procssing_DeviceBehfa" type="button" (click)="ReadData_DeviceBehfa()" class="btn btn-info"
        style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    </div>
  </div>

  <div *ngIf="inner_MultiSelectTools" class="mb-3">
    <div class="row">
      <div  class="form-group col-md-6">
        <button type="button" class="btn btn-success ml-2" [disabled]="CurrentDisplayedResults.length === 0"
          (click)="SelectAllCurrentResults()">
          <i class="fa fa-check-square-o"></i> انتخاب همه
        </button>
        <button type="button" class="btn btn-warning ml-2" [disabled]="inner_SeletedDeviceBehfa.length === 0"
          (click)="ClearAllSelectedDevices()">
          <i class="fa fa-square-o"></i> لغو انتخاب همه
        </button>
      </div>
      <div  class="form-group col-md-6">
        <span class="badge badge-danger">تعداد انتخاب‌شده: {{ inner_SeletedDeviceBehfa.length }}</span>
      </div>
    </div>
    
  </div>

  <div class="table-responsive">
    <table class="mb-0 table table-bordered table-3 text-center table-striped">
      <thead style="background-color: #489b39; color: white;">
        <tr>
          <th *ngIf="inner_MultiSelectTools">
            <input type="checkbox" [checked]="AllCurrentResultsSelected" [indeterminate]="SomeCurrentResultsSelected"
              [disabled]="CurrentDisplayedResults.length === 0"
              (change)="ToggleAllCurrentResults($any($event.target).checked)">
          </th>
          <th>#</th>
          <th>شناسه سیستم</th>
          <th>Description</th>
          <th>Manufacturer</th>
          <th>Model</th>
          <th>Code BEHFA</th>
          <th>امکانات</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of DataList_DeviceBehfa
        | paginate
                : {
                    id: 'DataList_DeviceBehfa',
                    itemsPerPage: 50,
                    currentPage: page,
                    totalItems: (DataList_DeviceBehfa).length
                  }">
          <td *ngIf="inner_MultiSelectTools"><input type="checkbox" [checked]="Check_InList(item)"
              (change)="ToggleSelectedDevice(item, $any($event.target).checked)"></td>
          <td>{{DataList_DeviceBehfa.indexOf(item)+1}}</td>
          <td>{{item.code}}</td>
          <td class="EnglishClm">{{item.description}}</td>
          <td class="EnglishClm">{{item.manufacturer}}</td>
          <td class="EnglishClm">{{item.model}}</td>
          <td class="EnglishClm">{{item.codeBEHFA}}</td>
          <td (click)="Set_Selected_DeviceBehfa_Record(item)" *ngIf="!inner_MultiSelectTools && !Check_InList(item)"
            style="cursor: pointer;">
            <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
          </td>
          <td *ngIf="!inner_MultiSelectTools && Check_InList(item)">
            <p style="color: green;">انتخاب شده است</p>
          </td>
          <td *ngIf="inner_MultiSelectTools">
            <span [style.color]="Check_InList(item) ? 'green' : 'inherit'">{{ Check_InList(item) ? 'انتخاب شده' :
              'انتخاب نشده' }}</span>
          </td>

        </tr>
      </tbody>
    </table>
  </div>

  <pagination-controls id="DataList_DeviceBehfa" nextLabel="بعدی" previousLabel="قبلی"
    (pageChange)="page = $event"></pagination-controls>

</div>